import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendGoogleAnalyticsPageView } from "@/lib/cookieConsent";

/**
 * Sends a page_view event to Google Analytics on every route change.
 * gtag.js only auto-fires page_view on initial loads, so SPA navigations need this.
 * The helper only emits once Google consent state has been explicitly granted.
 */
export function GoogleAnalyticsRouteTracker() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    sendGoogleAnalyticsPageView();
  }, [pathname, search, hash]);

  return null;
}
